import { supabase } from "../supabase";
import type { ScenarioRow } from "./scenario";

const COLUMNS =
  "id, slug, status, version, roles, skill_tags, content, sample, approved_at, updated_at, " +
  "scenario_change(status, content, updated_at), scenario_site(site_id)";

/** A pending change comes back as an object or a one-item list, depending on the API's guess. */
function tidyRow(row: ScenarioRow): ScenarioRow {
  const c = row.scenario_change as unknown;
  return { ...row, scenario_change: (Array.isArray(c) ? c[0] : c) ?? null };
}

export async function listScenarios(): Promise<ScenarioRow[]> {
  const { data, error } = await supabase.from("scenario").select(COLUMNS).order("updated_at", { ascending: false });
  if (error) throw error;
  return (data as unknown as ScenarioRow[]).map(tidyRow);
}

export async function getScenario(id: string): Promise<ScenarioRow | null> {
  const { data, error } = await supabase.from("scenario").select(COLUMNS).eq("id", id).maybeSingle();
  if (error) throw error;
  return data ? tidyRow(data as unknown as ScenarioRow) : null;
}
